import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyEntrySheetFormatData,
  provideEntrySheetFormatData,
  useEntrySheetHistories
} from '@/composables/format-edit/useEntrySheetHistories'
import EntrySheetEduHistoryCard from '@/components/format-edit/entry-sheet/EntrySheetEduHistoryCard.vue'
import EntrySheetTextFieldCard from '@/components/format-edit/entry-sheet/EntrySheetTextFieldCard.vue'
import EntrySheetCreateDateCard from '@/components/format-edit/entry-sheet/EntrySheetCreateDateCard.vue'
import EntrySheetConfirmCard from '@/components/format-edit/entry-sheet/EntrySheetConfirmCard.vue'
import DownloadItem from '@/components/formats/CommonParts/DownloadItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EntrySheetEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: { errorMessages?: Record<string, string> } | null
  currentCardId?: string
  exampleSentences?: Record<string, unknown>
};



const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'entrysheet',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyEntrySheetFormatData
})
provideEntrySheetFormatData(formatData)

const {
  activeHistoryItem,
  educationalResetDialogVisible,
  setEducationalBackgrounds,
  resetEducationalBackgrounds,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useEntrySheetHistories(formatData)

const descriptionMaxLength = 80
const textareaMinRows = 3
const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

const getMode = computed(() => process.env.VUE_APP_MODE)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  formatData.registYagioffer = true
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

return { __sfc: true,props, formLib, formatData, activeHistoryItem, educationalResetDialogVisible, setEducationalBackgrounds, resetEducationalBackgrounds, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, activateHistoryItem, descriptionMaxLength, textareaMinRows, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, previewErrors, getMode, dataChanged, EntrySheetEduHistoryCard, EntrySheetTextFieldCard, EntrySheetCreateDateCard, EntrySheetConfirmCard, DownloadItem }
}

})